export enum JobType {
  Reminder1 = 'Reminder 1',
  Reminder2 = 'Reminder 2',
  Scheduled = 'Scheduled',
  Prescription = 'Prescription',
  RhinoBlast = 'RhinoBlast',
  Conversation = 'Conversation',
}
